const isIphone = (() => {
	if (typeof window === `undefined` || typeof navigator === `undefined`) return false;
		return /iPhone/i.test(navigator.userAgent || navigator.vendor || (window.opera && window.opera.toString() === `[object Opera]`))
})();
export default isIphone;